export default "__VITE_ASSET__C_4I9_tF__"